import { render, staticRenderFns } from "./ordersFeatureData.vue?vue&type=template&id=388b71b4"
import script from "./ordersFeatureData.vue?vue&type=script&lang=js"
export * from "./ordersFeatureData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports